import React, { Dispatch, useEffect, useMemo, useState } from "react"
import { useDispatch } from "react-redux"
import { get, isEmpty, findKey } from "lodash"

import { Panel } from "components/organisms/panel"
import { InfoTable } from "components/molecules/table"
import { infoTableColumns } from "config/table_columns"
import { MainIndexList } from "components/organisms/panel/mainIndexList"
import { NewsList } from "components/organisms/panel/newsList"
import { APIResponse } from "redux/apis/types"
import { usePriceListAction } from "components/actions/priceList"
import MiddleChart from "components/molecules/chart/middleChart"
import { changeSymbol, changeSpModalSymbol } from "redux/ducks/Chart"
import ClassNames from "classnames"
import uuid from "uuid"
import { ROUTE_LIST } from "config/const"
import { MainContainer } from "components/molecules/utils/mainContainer"
import { checkIsSp } from "utils/util"
import { DataDescription } from "../../organisms/panel/dataDescription"
import { MainIndexDisclaimerText } from "config/disclaimerText"

type PropsType = {
  IndexData: APIResponse.Res
  indexListAction: Dispatch<usePriceListAction>
  detailsData: APIResponse.Res
  selectData: number
  setSelectData: Function
  transitionData: object
}

export const IndexesTemplate = (props: PropsType) => {
  const isPhone = useMemo(() => {
    return checkIsSp()
  }, [])
  const [isVisible, setVisible] = useState(true)
  const [checkTransitionData, setCheckTransitionData] = useState(false)

  const dispatch = useDispatch()
  const canvasId = useMemo(() => {
    return uuid()
  }, [])

  useEffect(() => {
    const data = get(props.IndexData, "ResultList")
    if (isEmpty(data) || !isEmpty(props.transitionData)) return
    dispatch(changeSymbol(canvasId, data[0]))
  }, [props.IndexData, isVisible])

  useEffect(() => {
    if (isEmpty(props.transitionData) || isEmpty(props.IndexData)) return
    if (props.transitionData && !checkTransitionData) {
      const data = get(props.IndexData, "ResultList")
      const activePosition = findKey(data, (row: object) => {
        const symbol = get(props.transitionData, "Symbol")
        return get(row, "Symbol") === symbol
      })
      props.setSelectData(Number(activePosition))
      dispatch(changeSymbol(canvasId, props.transitionData))
      setCheckTransitionData(true)
    }
  }, [props.transitionData, props.IndexData])

  return (
    <MainContainer className="top-index-template">
      <div className="symmetry-layout top-index">
        <div
          className={ClassNames("index-list-block", {
            "contents-block": isVisible,
            "mini-chart-block": !isVisible,
          })}
        >
          <MainIndexList
            indexData={get(props.IndexData, "ResultList", [])}
            reloadList={() =>
              props.indexListAction({ type: "PRICE_LIST_RELOAD" })
            }
            onClick={(data: any, i: number) => {
              !isPhone
                ? dispatch(changeSymbol(canvasId, data))
                : dispatch(changeSpModalSymbol(data))
              props.setSelectData(i)
            }}
            setVisible={setVisible}
            selectData={props.selectData}
            setSelectData={props.setSelectData}
            canvasId={canvasId}
            scrollable={true}
          />
        </div>
        {isVisible && !isPhone && (
          <div className="contents-block index-detail-block">
            <div className="contents-nest-block">
              <Panel
                className="panel-main-index"
                title=""
                nonePanelHeader={true}
              >
                <MiddleChart id={canvasId} />
                <InfoTable
                  list={infoTableColumns.common_list}
                  data={get(props.detailsData, "Symbol")}
                  className="table-striped table-index-detail"
                  wrapperCls="index-detail-table-row"
                />
              </Panel>
              <NewsList route={ROUTE_LIST.TOP_INDEX} />
            </div>
          </div>
        )}
      </div>
      {!isPhone && (
        <DataDescription
          className="panel-data-description"
          children={MainIndexDisclaimerText}
        />
      )}
    </MainContainer>
  )
}
